/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BCMBookingIdRemarkRuleFormConfiguration,
    BCMBookingIdRemarkRuleFormConfigurationFromJSON,
    BCMBookingIdRemarkRuleFormConfigurationToJSON,
    BCMBookingIdRemarkRuleFormData,
    BCMBookingIdRemarkRuleFormDataFromJSON,
    BCMBookingIdRemarkRuleFormDataToJSON,
    BCMBookingIdRemarkRuleFormValidationData,
    BCMBookingIdRemarkRuleFormValidationDataFromJSON,
    BCMBookingIdRemarkRuleFormValidationDataToJSON,
} from '../models';

export interface ApiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormCreatePostRequest {
    bCMBookingIdRemarkRuleFormData?: BCMBookingIdRemarkRuleFormData;
}

export interface ApiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormDataGetRequest {
    id?: string;
}

export interface ApiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormUpdatePostRequest {
    bCMBookingIdRemarkRuleFormData?: BCMBookingIdRemarkRuleFormData;
}

export interface ApiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormValidatePostRequest {
    bCMBookingIdRemarkRuleFormData?: BCMBookingIdRemarkRuleFormData;
}

/**
 * no description
 */
export class BCMBookingIdRemarkRuleFormApi extends runtime.BaseAPI {

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormConfigurationGetRaw(): Promise<runtime.ApiResponse<BCMBookingIdRemarkRuleFormConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/BookingIdRemark/BCMBookingIdRemarkRuleForm/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BCMBookingIdRemarkRuleFormConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormConfigurationGet(): Promise<BCMBookingIdRemarkRuleFormConfiguration> {
        const response = await this.apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormCreatePostRaw(requestParameters: ApiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormCreatePostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/BookingIdRemark/BCMBookingIdRemarkRuleForm/Create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BCMBookingIdRemarkRuleFormDataToJSON(requestParameters.bCMBookingIdRemarkRuleFormData),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormCreatePost(requestParameters: ApiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormCreatePostRequest): Promise<string> {
        const response = await this.apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormCreatePostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormDataGetRaw(requestParameters: ApiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormDataGetRequest): Promise<runtime.ApiResponse<BCMBookingIdRemarkRuleFormData>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/BookingIdRemark/BCMBookingIdRemarkRuleForm/Data`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BCMBookingIdRemarkRuleFormDataFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormDataGet(requestParameters: ApiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormDataGetRequest): Promise<BCMBookingIdRemarkRuleFormData> {
        const response = await this.apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormDataGetRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormUpdatePostRaw(requestParameters: ApiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormUpdatePostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/BookingIdRemark/BCMBookingIdRemarkRuleForm/Update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BCMBookingIdRemarkRuleFormDataToJSON(requestParameters.bCMBookingIdRemarkRuleFormData),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormUpdatePost(requestParameters: ApiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormUpdatePostRequest): Promise<void> {
        await this.apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormUpdatePostRaw(requestParameters);
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormValidatePostRaw(requestParameters: ApiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormValidatePostRequest): Promise<runtime.ApiResponse<BCMBookingIdRemarkRuleFormValidationData>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/BookingCreateManager/BookingIdRemark/BCMBookingIdRemarkRuleForm/Validate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BCMBookingIdRemarkRuleFormDataToJSON(requestParameters.bCMBookingIdRemarkRuleFormData),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => BCMBookingIdRemarkRuleFormValidationDataFromJSON(jsonValue));
    }

    /**
     */
    async apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormValidatePost(requestParameters: ApiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormValidatePostRequest): Promise<BCMBookingIdRemarkRuleFormValidationData> {
        const response = await this.apiBookingCreateManagerBookingIdRemarkBCMBookingIdRemarkRuleFormValidatePostRaw(requestParameters);
        return await response.value();
    }

}
